/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AutoSaveDto } from '../../models/auto-save-dto';

export interface Get1$Params {
  typeCode: 'PATENTRY' | 'DNRWKUP' | 'CORDSHP' | 'PATCPENTRY' | 'NEWWKUP' | 'SECWKUP';
}

export function get1(http: HttpClient, rootUrl: string, params: Get1$Params, context?: HttpContext): Observable<StrictHttpResponse<AutoSaveDto>> {
  const rb = new RequestBuilder(rootUrl, get1.PATH, 'get');
  if (params) {
    rb.path('typeCode', params.typeCode, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AutoSaveDto>;
    })
  );
}

get1.PATH = '/autosaves/{typeCode}';
